import { setSelectOptions } from "utils/common";

/**
 * 版本章節的類型
 */
export const DATA_TYPE = {
	none: 0,
	/**
	 * 章節重點
	 */
	chapter: 1,
	/**
	 * 大考冊次
	 */
	book: 2,
	/**
	 * 主題式無課綱
	 */
	topic: 3,
	/**
	 * CMS章節
	 */
	cms: 4,
};

export const STATUS = {
	none: 0,
	uploadSuccess: 10,
	uploadFailed: 99,
	processing: 2,
	uploading: 3,
	fileNameError: 4,
	headerError: 5,
	subjectError: 6,
	chapterError: 8,
	contentError: 7,
};

export const statusMapper = (status) => {
	switch (status) {
		case STATUS.processing:
			return "等待處理中";
		case STATUS.uploading:
			return "上傳中";
		case STATUS.fileNameError:
			return "檔名錯誤";
		case STATUS.headerError:
			return "表頭錯誤";
		case STATUS.subjectError:
			return "科目錯誤";
		case STATUS.contentError:
			return "內容錯誤";
		case STATUS.chapterError:
			return "章節錯誤";
		case STATUS.uploadSuccess:
			return "上傳成功";
		case STATUS.uploadFailed:
			return "上傳失敗";
		case STATUS.none:
		default:
			return "無";
	}
};

export const CURRICULUM_OPTIONS = setSelectOptions([
	{ code: "", name: "所有課綱" },
	{ code: "108", name: "108課綱" },
	{ code: "99", name: "99課綱" },
]);

export const CURRICULUM_OPTIONS_WITHOUT_ALL = CURRICULUM_OPTIONS.slice(1);

export const VERSION_OPTIONS = setSelectOptions([
	{ code: "", name: "所有版本" },
	{ code: "N", name: "南一" },
	{ code: "K", name: "康軒" },
	{ code: "H", name: "翰林" },
]);
